export enum EntityStoreKey {
  TellentMembers = 'TellentMembers',
  TellentApps = 'TellentApps',
}
